import { useQuery } from '@tanstack/react-query';
import { fetchPositions } from './api';
import { positionQueryKey } from './key';
import { mapPositionsToOptions } from './selector';
import type { PositionItem } from './type';
export const usePositions = (searchText: string) => useQuery({
  queryKey: positionQueryKey.list(searchText),
  queryFn: () => fetchPositions(searchText),
  select: (data: PositionItem[]) => mapPositionsToOptions(data),
  initialData: []
});